export const isSafari = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return (
    userAgent.includes('safari') && !userAgent.includes('chrome') && !userAgent.includes('android')
  )
}
